import React, { Fragment } from 'react';
import { ActivityIndicator } from 'react-native-paper';
import { MainColors } from '../constants/Colors';

const LoadingIndicator = ({ isLoading, children }) => (isLoading ? 
    <ActivityIndicator style={{ flex: 1 }} animating={true} color={MainColors.primary} />
: <Fragment>{children}</Fragment>)

export default LoadingIndicator;